import React, { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import Button from "../../../Button/Button";
import { InputField1 } from "../../../InputField1/InputField1";
import { SimpleTextArea } from "../../../SimpleTextArea/SimpleTextArea";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { useAddTemplateTextTable } from "../../../../hooks/useContent";
import { RowElement } from "../../Sliders/AddSlide";
import { errorMessage } from "../../../../utils/message";
import Level2Table from "../../ProductProperty/level2/Level2Table";

function TemplateGeneratory({ refresh, setRefresh }) {
  const {
    mutateAsync: addTextTempalte,
    isLoading: reqLoading,
    isError: reqError,
  } = useAddTemplateTextTable();

  const [newTempalte, setNewTemplate] = useState({
    name: "",
    content: "",
  });

  const addTextTableTempalte = () => {
    addTextTempalte(newTempalte).then((res) => {
      setNewTemplate({ name: "", content: "" });
      setRefresh(!refresh);
    });
  };

  const validateForm = () => {
    let isValid = true;

    if (newTempalte?.name.length < 1) {
      errorMessage("لطفا نام را وارد کنید");
      isValid = false;
    }
    if (newTempalte?.content.length < 1) {
      errorMessage("لطفا محتوا جدول را وارد کنید");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = () => {
    validateForm() && addTextTableTempalte();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewTemplate({ ...newTempalte, [name]: value });
  };

  return (
    <TemplateGeneratorStyle>
      <GeneratorWrapper>
        <RowDiv>
          <RowElement>
            <InputField1
              type="text"
              name="name"
              label="نام "
              onChange={handleChange}
              value={newTempalte?.name}
              placeholder="نام .."
              maxLenght="50"
            />
          </RowElement>
        </RowDiv>
        <SimpleTextArea
          label={"محتوای جدول"}
          name="content"
          value={newTempalte?.content}
          onChange={handleChange}
          placeholder={"محتوای قالب..."}
          rows={5}
        />
        <Button
          bgColor={"#4c78a9"}
          small={"200px"}
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ثبت جدول
            </Typography>
          )}
        </Button>
      </GeneratorWrapper>
    </TemplateGeneratorStyle>
  );
}

const TemplateGeneratorStyle = styled.div``;

const GeneratorWrapper = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const RowDiv = styled.div`
  margin-bottom: 2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 1rem;
  column-gap: 4rem;
  align-items: center;
  justify-content: flex-start;
`;

export default TemplateGeneratory;
